import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {DiagtoolOverviewComponent} from './components/diagtool-overview/diagtool-overview.component';

const routes: Routes = [
  { path: 'diagtool', component: DiagtoolOverviewComponent },
  { path: 'diagtool/history', component: DiagtoolOverviewComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class DiagtoolRoutingModule { }
